import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Trans } from "react-i18next";
import { GetAllActivites } from "../../services/backendServices";
import moment from "moment";
import { useHistory } from "react-router-dom";
const NotificationDropdown = () => {
  const [notifications, setNotifications] = useState([]);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const history = useHistory(); // Initialize history
  useEffect(() => {
    fetchNotification();
  }, []);

  const fetchNotification = async () => {
    try {
      const res = await GetAllActivites({ offset: 0, limit: 5 });
      if (res && res.status) {
        setNotifications(res.data);
      } else {
        console.log("Error: Failed to fetch notifications");
      }
    } catch (e) {
      console.log("Error fetching notifications:", e);
    }
  };
  // Navigate to the activity log page
  const showAllActivities = () => {
    history.push("/profile/activitylog");
    setDropdownOpen(false); // Close the dropdown
  };

  // Get icon based on activity type
  const getActivityIcon = (activityType) => {
    switch (activityType) {
      case "login":
        return (
          <i
            className="mdi mdi-login text-primary"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      case "fundtransfer":
        return (
          <i
            className="mdi mdi-cash-transfer text-success"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      case "planpurchase":
        return (
          <i
            className="mdi mdi-cart-outline text-info"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      case "withdrawrequest":
        return (
          <i
            className="mdi mdi-bank-outline text-warning"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      case "newusers":
        return (
          <i
            className="mdi mdi-account-plus-outline text-primary"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      case "loginpasswordupdated":
        return (
          <i
            className="mdi mdi-lock-reset text-danger"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      case "transactionpasswordupdated":
        return (
          <i
            className="mdi mdi-shield-lock-outline text-danger"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
      default:
        return (
          <i
            className="mdi mdi-information-outline text-muted"
            style={{ fontSize: "18px", marginRight: "10px" }}
          ></i>
        );
    }
  };

  return (
    <Dropdown
      alignRight
      show={isDropdownOpen}
      onToggle={() => setDropdownOpen(!isDropdownOpen)}
    >
      <Dropdown.Toggle
        as="button"
        className="btn align-self-center position-relative p-0"
      >
        <i
          className="mdi mdi-bell-outline m-0"
          style={{ fontSize: "24px", color: "#616F8C" }}
        ></i>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="p-3"
        style={{
          width: "350px",
          maxHeight: "400px",
          overflowY: "auto",
          backgroundColor: "#f4f6f8",
          borderRadius: "8px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0">
            <Trans>Notifications</Trans>
          </h6>
          <button className="btn btn-link p-0" onClick={showAllActivities}>
            <Trans>View All</Trans>
          </button>
        </div>

        <div className="notifications-list">
          {notifications.length > 0 ? (
            notifications.map((notification) => (
              <div
                key={notification.usact_id}
                className={`d-flex justify-content-start align-items-start p-2 mb-2 rounded ${
                  notification.isRead ? "bg-light" : "bg-white"
                } notification-item`}
                style={{
                  borderBottom: "1px solid #e9ecef",
                  cursor: "pointer",
                  transition: "background-color 0.2s ease",
                }}
              >
                {getActivityIcon(notification.activity_type)}
                <div>
                  <div
                    className="text-dark"
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: notification.isRead ? "normal" : "bold",
                    }}
                  >
                    {notification.activity_note}
                  </div>
                  <small className="text-muted text-end">
                    {moment(notification.create_time).fromNow()}
                  </small>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-3 text-muted">
              <Trans>No notifications available</Trans>
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationDropdown;
